import { create } from "zustand"

// PERSON-CARD (T2, 2026-07-06): global open/close state for the merged-contact person card, so
// ANY avatar anywhere in the product (Directory rows today; TeeUp participants / inbox / map
// later) can open it without threading props through the whole tree -- same "one Zustand store,
// mounted once at App root" shape already proven by createTeeupStore's remakeDraft.
interface PersonCardStore {
  openPersonId: string | null
  open: (personId: string) => void
  close: () => void
}

export const usePersonCardStore = create<PersonCardStore>()(set => ({
  openPersonId: null,
  open: personId => set({ openPersonId: personId }),
  close: () => set({ openPersonId: null }),
}))
